import { userApi } from "@queries/User";
import { useMutation } from "@tanstack/react-query";

export default function useChangeOrganization() {
  return useMutation({ mutationFn: userApi.changeOrganization });
}
